export interface Consumidor {
  id: number;
  nombre: string;
  clave: string;
  activo: boolean;
  clienteId: string | null;

  modo: 'oauth' | 'llave';
  exigeFirma: boolean;
  alcances: string[];
  ipsAutorizadas: string[];
  peticionesPorMinuto: number;
  minutosDeToken: number;
}

export interface Credenciales {
  id: number;
  clave: string;
  clienteId: string | null;
  secreto: string | null;
  llave: string | null;
  secretoDeFirma: string | null;
}

export interface TokenEmitido {
  id: number;
  prefijo: string;
  alcances: string[];
  creadoEn: string;
  expiraEn: string;
  revocadoEn: string | null;
  ipOrigen: string | null;
  vivo: boolean;
}

export interface Llamada {
  id: number;

  consumidor: string | null;
  ruta: string;
  metodo: string;
  identificacion: string | null;
  http: number;
  codigoError: string | null;
  duracionMs: number;
  ip: string | null;
  ocurridoEn: string;
}

export interface PanelDeTrafico {
  consumidores: number;
  consumidoresActivos: number;
  peticionesHoy: number;
  peticionesAyer: number;
  peticiones7d: number;
  peticiones30d: number;
  tasaDeError: number;
  latenciaMedia: number;
  porConsumidor: Array<{
    id: number;
    nombre: string;
    peticiones: number;
    errores: number;
    latenciaMedia: number;
  }>;
  porEstado: Array<{ http: number; peticiones: number }>;
  porDia: Array<{ dia: string; peticiones: number; errores: number }>;
}

export const ALCANCES = [
  {
    codigo: 'consulta:deuda',
    rotulo: 'Consultar deuda',
    detalle: 'Cuánto debe una cédula, con su interés de mora',
    delicado: false,
  },
  {
    codigo: 'consulta:cliente',
    rotulo: 'Consultar contribuyente',
    detalle: 'Los datos del titular sin su deuda',
    delicado: false,
  },
  {
    codigo: 'consulta:comprobante',
    rotulo: 'Bajar comprobantes',
    detalle: 'El RIDE de las facturas y el historial de pagos de una persona',
    delicado: false,
  },
  {
    codigo: 'certificado:no-adeudar',
    rotulo: 'Certificados de no adeudar',
    detalle: 'Emitirlos para una persona y bajar su PDF firmado. Lo usa la ventanilla',
    delicado: true,
  },
  {
    codigo: 'pago:en-linea',
    rotulo: 'Pagos en línea',
    detalle: 'Registrar lo que el ciudadano pagó con tarjeta en la ventanilla. Mueve dinero',
    delicado: true,
  },
  {
    codigo: 'recaudacion',
    rotulo: 'Recaudar',
    detalle: 'Cobrar y reversar cobros de cooperativas',
    delicado: true,
  },
] as const;
